<app-loader *ngIf="loading"></app-loader>
<vg-player *ngIf="!loading">
    <vg-overlay-play></vg-overlay-play>
    <vg-buffering></vg-buffering>
    <video #media [vgMedia]="$any(media)" id="video" preload="auto" controls>
        <source *ngIf="videoBytes !== ''" [src]="videoBytes" type="video/mp4"/>
    </video>
</vg-player>